import { render, staticRenderFns } from "./VueSlide.vue?vue&type=template&id=55518610"
import script from "./VueSlide.vue?vue&type=script&lang=js"
export * from "./VueSlide.vue?vue&type=script&lang=js"
import style0 from "./VueSlide.vue?vue&type=style&index=0&id=55518610&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports